module.exports = __webpack_public_path__ + "static/img/RAPS-1P_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS-1P_1.png
// module id = QlLJ
// module chunks = 0